
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-33d5e096!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PicturewallList.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PicturewallList.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-33d5e096!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PicturewallList.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/components/Lists/PicturewallList.vue
// module id = 124
// module chunks = 0